/**
 * Sequences Page
 * Sequence builder interface (placeholder)
 */

export function SequencesPage() {
  return (
    <div className="flex-1 p-8 overflow-auto bg-zinc-950">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-white mb-4">Sequences</h1>
        <p className="text-gray-400">
          Sequence builder interface coming soon...
        </p>
      </div>
    </div>
  );
}
